import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { TransactionSource } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface TransactionOriginFilterProps {
  originSet: Set<string>
  handleOriginSelection: (source: string) => Set<string>
}

const TransactionOriginFilter: React.FC<TransactionOriginFilterProps> = ({
  originSet,
  handleOriginSelection,
}) => {
  const translate = useTranslate()
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Transaction Origin')}
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="transaction-origin-virtual"
          onChange={(): void => {
            handleOriginSelection(TransactionSource.Virtual)
          }}
          checked={originSet.has(TransactionSource.Virtual)}
          aria-label={translate('Virtual')}
        />
        <label
          htmlFor="transaction-origin-virtual"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Virtual')}
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="transaction-origin-physical"
          onChange={(): void => {
            handleOriginSelection(TransactionSource.Physical)
          }}
          checked={originSet.has(TransactionSource.Physical)}
          aria-label={translate('Physical')}
        />
        <label
          htmlFor="transaction-origin-physical"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Physical')}
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="transaction-origin-other"
          onChange={(): void => {
            handleOriginSelection(TransactionSource.Other)
          }}
          checked={originSet.has(TransactionSource.Other)}
          aria-label={translate('Other')}
        />
        <label
          htmlFor="transaction-origin-other"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Other')}
        </label>
      </div>
    </div>
  )
}

export default TransactionOriginFilter
